<template>
    <v-container>
        <v-row column justify-center align-center dense>
            <v-col v-for="card in sortedItems" :key="card.id" cols="6" md="3">
                <v-card class="pb-4">
                    <EmbedSanityImage
                        v-if="
                            card.seometa &&
                            card.seometa.sanityImageOG &&
                            card.seometa.sanityImageOG.selectedImage
                        "
                        :selectedImage="
                            card.seometa &&
                            card.seometa.sanityImageOG &&
                            card.seometa.sanityImageOG.selectedImage
                        "
                        :height="$vuetify.breakpoint.mdAndUp ? `300` : `464`"
                        :width="$vuetify.breakpoint.mdAndUp ? `300` : `464`"
                        :inner-classes="`white--text align-end industry-thumb ${
                            $vuetify.breakpoint.mdAndUp ? 'h250' : 'h350'
                        }`"
                        img-classes="bbrr-0 bblr-0"
                        wrapper-classes="mb-0"
                    />
                    <v-card-title class="text-center">
                        {{
                            $i18n.locale
                                ? card.title[$i18n.locale]
                                : card.title.en
                        }}</v-card-title
                    >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            small
                            color="primary"
                            :to="getCustomLocalePath(card)"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'readMore' }"
                        /></v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import EmbedCloudinary2 from '~/components/embeds/EmbedCloudinary2.vue'
import EmbedSanityImage from '~/components/embeds/EmbedSanityImage.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'FeaturedIndustries',
    components: {
        EmbedCloudinary2,
        EmbedSanityImage,
        TranslatableStringComponent,
    },
    props: {
        items: {
            type: Array,
            default: null,
        },
    },
    computed: {
        sortedItems() {
            let sortedItems = this.items
            sortedItems.sort((a, b) => {
                return a.sequence > b.sequence ? 1 : -1
            })
            return sortedItems
        },
    },
}
</script>
